import { render, staticRenderFns } from "./Error404Page.vue?vue&type=template&id=4a1e4492&"
import script from "./Error404Page.vue?vue&type=script&lang=ts&"
export * from "./Error404Page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports